import { type ChangeEvent, type FormEvent, PureComponent, type ReactNode } from "react";
import { MaterialInput } from "./materialInput/MaterialInput";
import classNames from "classnames";
import { IconType } from "./icon/IconType";
import { Icon } from "./icon/Icon";
import { type WithTranslation, withTranslation as withTranslationBase } from "react-i18next";
import type { SxProps, TextFieldPropsSizeOverrides, Theme } from "@mui/material";
import type { OverridableStringUnion } from "@mui/types";

interface SearchInputProps extends WithTranslation {
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  searchDisabled?: boolean;
  className?: string;
  label: ReactNode;
  helperLabel?: ReactNode;
  id?: string;
  shrink?: boolean;
  onChange?: (newVal: string) => void;
  onSearch?: () => void;
  register?: any;
  "data-test-id"?: string;
  size?: OverridableStringUnion<"small" | "medium", TextFieldPropsSizeOverrides>;
  sx?: SxProps<Theme>;
}

class SearchInput extends PureComponent<SearchInputProps, {}> {
  constructor(props: SearchInputProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (this.props.onSearch) {
      this.props.onSearch();
      (document.activeElement as HTMLElement).blur();
    }
  }

  onChange(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    if (this.props.onChange) {
      const newVal = e.target.value;
      if (newVal !== this.props.value) {
        this.props.onChange(newVal);
      }
    }
  }

  render() {
    const {
      value,
      placeholder,
      disabled,
      searchDisabled,
      className,
      id,
      label,
      helperLabel,
      shrink,
      register,
      "data-test-id": testId,
      sx,
      size,
    } = this.props;

    const disableBtn = disabled || searchDisabled;
    const formCls = classNames("scha__search-input", className, {
      "scha__search-input--material": true,
    });

    return (
      <form className={formCls} onSubmit={this.onSubmit}>
        <MaterialInput
          value={value}
          placeholder={placeholder}
          onChange={this.onChange}
          disabled={disabled}
          label={label}
          id={id}
          shrink={shrink}
          helperLabel={helperLabel}
          data-test-id={`${testId}-input`}
          inputRef={register}
          name={id}
          sx={sx}
          size={size}
          endAdornment={
            <button type="submit" disabled={disableBtn} data-test-id={`${testId}-submit`}>
              <Icon type={IconType.Search} />
            </button>
          }
        />
      </form>
    );
  }
}

export default withTranslationBase()(SearchInput);
